import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { CredentialsService } from '../../core/misc';
import { UserInputCheck } from '../../core/model';

export abstract class UsernameValidator {
  public static available(service: CredentialsService, oldUserName?: string): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value || !control.dirty) {
        return of(null);
      }

      if (oldUserName && oldUserName === control.value) {
        return of(null);
      }

      return timer(500) // no spamming allowed
        .pipe(
          switchMap(() => service.isUsernameAvailable(control.value)),
          map((check: UserInputCheck) => {
            return check.valid ? null : { username: check };
          }),
          take(1)
        );
    };
  }
}
